const DB_URL = "https://shopify-likes-e0091-default-rtdb.asia-southeast1.firebasedatabase.app";
const customerId = window.__shopify_customer_id || null;

function formatCount(count) {
  if (count < 1000) return count;
  return Math.floor(count / 1000) + 'k';
}

async function getLikeCount(productId) {
  const res = await fetch(`${DB_URL}/likes/${productId}.json`);
  const val = await res.json();
  return val ?? 0;
}

async function getHasLiked(customerId, productId) {
  const res = await fetch(`${DB_URL}/liked/${customerId}/${productId}.json`);
  const val = await res.json();
  return val === true;
}

async function incrementLike(productId) {
  // トランザクションの代わりにREST APIのtransactionを使用
  const res = await fetch(`${DB_URL}/likes/${productId}.json`);
  const current = (await res.json()) ?? 0;
  await fetch(`${DB_URL}/likes/${productId}.json`, {
    method: 'PUT',
    body: JSON.stringify(current + 1)
  });
  return current + 1;
}

async function decrementLike(productId) {
  const res = await fetch(`${DB_URL}/likes/${productId}.json`);
  const current = (await res.json()) ?? 0;
  const next = Math.max(current - 1, 0);
  await fetch(`${DB_URL}/likes/${productId}.json`, {
    method: 'PUT',
    body: JSON.stringify(next)
  });
  return next;
}

async function setLiked(customerId, productId) {
  await fetch(`${DB_URL}/liked/${customerId}/${productId}.json`, {
    method: 'PUT',
    body: JSON.stringify(true)
  });
}

async function removeLiked(customerId, productId) {
  await fetch(`${DB_URL}/liked/${customerId}/${productId}.json`, {
    method: 'DELETE'
  });
}

async function initLikeButton(button) {
  const productId = button.dataset.productId;
  const countEl = button.querySelector(".like-count");

  if (!productId) {
    button.style.display = "none";
    return;
  }

  // いいね数を取得
  const count = await getLikeCount(productId);
  countEl.textContent = formatCount(count);

  // Shopify未ログインならアラート
  if (!customerId) {
    button.disabled = false;
    button.onclick = () => {
      alert('いいねするにはログインが必要です。');
    };
    return;
  }

  // いいね済みか確認
  const hasLiked = await getHasLiked(customerId, productId);

  button.disabled = false;
  if (hasLiked) {
    button.classList.add("liked");
    button.onclick = () => handleUnlike(button, productId, customerId);
  } else {
    button.onclick = () => handleLike(button, productId, customerId);
  }
}

async function handleLike(button, productId, customerId) {
  button.disabled = true;

  try {
    await setLiked(customerId, productId);
    const newCount = await incrementLike(productId);

    const countEl = button.querySelector(".like-count");
    countEl.textContent = formatCount(newCount);

    button.classList.add("liked");
    button.disabled = false;
    button.onclick = () => handleUnlike(button, productId, customerId);
  } catch (err) {
    console.error("いいね処理に失敗しました:", err);
    button.disabled = false;
  }
}

async function handleUnlike(button, productId, customerId) {
  button.disabled = true;

  try {
    await removeLiked(customerId, productId);
    const newCount = await decrementLike(productId);

    const countEl = button.querySelector(".like-count");
    countEl.textContent = formatCount(newCount);

    button.classList.remove("liked");
    button.disabled = false;
    button.onclick = () => handleLike(button, productId, customerId);
  } catch (err) {
    console.error("いいね取り消しに失敗しました:", err);
    button.disabled = false;
  }
}

// 既存のボタンを初期化
document.querySelectorAll(".like-button").forEach(initLikeButton);

// 動的追加されたボタンも初期化
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType !== 1) return;
      if (node.matches?.(".like-button")) {
        initLikeButton(node);
      }
      node.querySelectorAll?.(".like-button").forEach(initLikeButton);
    });
  });
});

observer.observe(document.body, { childList: true, subtree: true });